import React, { Component, useState, useRef, useCallback } from 'react'
import { sagaModal } from 'redux-saga-modal'
import { Form, Table, Modal, Input, Divider, Col, Row, Button, message, Select } from 'antd'
import dayjs from 'dayjs'
import * as apis from '@/apis'
const { Option } = Select;
const { TextArea } = Input;


@Form.create()
class MgroupsDialog extends Component {
  state = {
    loading: false,
    skills: []
  }

  handleSubmit = e => {
    const { tenantId, type, mgroups = {}, ismodify, submitCallback, onSuccess } = this.props
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.error(err)
      }

      this.setState({ loading: true })
      if (ismodify !== "modify") {
        apis.createMgroups({
          name: values.name,
          desc: values.desc,
          productCategory: values.productCategory
        }).then(result => {
          message.success('添加成功')
          this.props.form.resetFields()
          onSuccess(result)
          submitCallback && submitCallback()

        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
          this.setState({
            loading: false
          })
        })
      } else {
        apis.updateManagers(mgroups._id, {
          name: values.name,
          desc: values.desc,
          productCategory: values.productCategory,
        }).then(result => {
          message.success('修改成功')
          this.props.form.resetFields()
          onSuccess(result)
          submitCallback && submitCallback()

        }).catch(err => {
          message.error(err.message || '发生错误')
        }).finally(() => {
          this.setState({
            loading: false
          })
        })


      }
    });
  }

  fetch = async () => {
    this.setState({ loading: true })
    const result = await apis.findRecommend()
    let category = result
    this.setState({
      category,
      loading: false
    })
  }

  componentDidMount() {
    this.fetch()
  }
  setproductCategory = (item) => {
    let list = null
    list = item.map(el => ele._id)
    return list
  }
  render() {
    const { type, mgroups = {}, ismodify } = this.props
    const { getFieldDecorator, validateFields, getFieldValue } = this.props.form
    const disabled = this.state.loading
    const mingzi = type === 'staff' ? '员工' : '客服'
    const category = this.state.category
    return (
      <div>
        <Form layout="inline" onSubmit={this.handleSubmit}>
          <Row>
            <Col span={24}>
              <Form.Item
                label="分组名称"
                required>
                {getFieldDecorator('name', {
                  initialValue: mgroups.name,
                  rules: [
                    {
                      required: true,
                      message: '请输入分组名称',
                    },
                  ],
                })(
                  <Input style={{ width: 300 }} autoFocus placeholder="请输入分组名称" />
                )}
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item
                label="分组描述"
                required>
                {getFieldDecorator('desc', {
                  initialValue: mgroups.desc,
                  rules: [
                    {
                      required: true,
                      message: '请输入分组描述',
                    },
                  ],
                })(
                  <TextArea style={{ width: 300 }} autoFocus placeholder="请输入分组描述" />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item label="产品分类" required>
                {getFieldDecorator('productCategory', {
                  initialValue: mgroups.productCategory?.map(ele => ele._id)
                })(
                  <Select mode="multiple" allowClear showArrow placeholder={`请选择产品分类`} style={{ width: 300 }}>
                    {
                      category?.map(ele => {
                        return <Option key={ele._id} value={ele._id}>{ele.name}</Option>
                      })
                    }
                  </Select>
                )}
              </Form.Item>
            </Col>
          </Row>
          <Form.Item style={{display:"block", marginTop: 10,textAlign:"center"}}>
                <Button type="primary" disabled={disabled} htmlType="submit">{ismodify === "modify" ? "确认修改" : "添加分组"}  </Button>
          </Form.Item>
        </Form>
      </div>
    )
  }
}

const TenantInfoDialog = ({
  modal,
  isOpen,
  show,
  update,
  destroy,
  click,
  submit,
  hide,
  showModal,
  updateModal,
  submitModal,
  clickModal,
  hideModal,
  destroyModal,
  ...ownProps
}) => (
  <Modal
    title={ownProps.title}
    destroyOnClose
    footer={null}
    width={480}
    style={{ top: 30 }}
    visible={isOpen}
    maskClosable={false}
    onCancel={hide}>
    <MgroupsDialog onSuccess={hide} {...ownProps} />
  </Modal>
)

export default sagaModal({
  name: 'MGROUPS_DIALOG',
})(TenantInfoDialog)
